import React from 'react';
import { DateTime } from 'luxon';
import { emptyObject } from 'ui-components/default-props/empty';
import { useSellerFormattedCurrency } from '../../../../hooks/use-seller-formatted-currency';
import { useLuxonUserDateFormat } from '../../../../hooks/use-datetime-formats';
import classnames from 'classnames';
import style from './style.module.less';

export const RateShoppedService = ({ isHighlighted = false, hasError = false, rateShoppedService = emptyObject }) => {
  const { deliveryDate, rateError, shippingServiceName, totalCost } = rateShoppedService;
  const dateFormat = useLuxonUserDateFormat();
  const deliveryDateParsed = deliveryDate?.length > 0 ? DateTime.fromISO(deliveryDate).toFormat(dateFormat) : '';
  const cost = useSellerFormattedCurrency(totalCost);
  return (
    <div
      className={classnames(style['rate-shopped-service'], {
        [style.highlighted]: isHighlighted,
      })}
    >
      <div>
        {shippingServiceName}
        {hasError && (
          <>
            {' - '}
            <span className={style['rate-error']}>{rateError}</span>
          </>
        )}
      </div>
      <div>{hasError ? '' : deliveryDateParsed}</div>
      <div className={style['align-right']}>{hasError || totalCost <= 0 ? '' : cost}</div>
    </div>
  );
};
